import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { recentPurchases } from '../data/content';
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let showTimer: number;
    let hideTimer: number;
    const cycle = () => {
      showTimer = window.setTimeout(() => {
        setOpen(true);
        hideTimer = window.setTimeout(() => {
          setOpen(false);
          setIndex(prev => (prev + 1) % recentPurchases.length);
          cycle();
        }, 5000);
      }, 9000);
    };
    cycle();
    return () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(hideTimer);
    };
  }, [dismissed, index]);
  if (dismissed) return null;
  const purchase = recentPurchases[index];
  const minutesAgo = 2 + index % 7;
  return <div className="pointer-events-none fixed bottom-24 left-3 z-30 w-[calc(100%-1.5rem)] max-w-[19rem] sm:left-5 sm:w-80" data-id="element-42" data-mp="165hc2uszy76i">
      <AnimatePresence data-id="element-43" data-mp="1164ou8y7qy3e">
        {open && <motion.div initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 12,
        scale: 0.98
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex items-start gap-3 rounded-2xl border border-navy-100 bg-white p-3 shadow-[0_12px_30px_rgba(6,18,37,0.18)]" role="status" data-id="element-44" data-mp="1fvsoz6unrqpj">
            <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-clinic-50" data-id="element-45" data-mp="x62l7u8x3ulh">
              <CheckCircle2Icon className="h-5 w-5 text-clinic-600" aria-hidden="true" data-id="element-46" data-mp="s4n1q6me1w57" />
            </span>
            <div className="min-w-0 flex-1" data-id="element-47" data-mp="28imy57m0z3np">
              <p className="text-[13px] font-bold leading-snug text-navy-900" data-id="element-48" data-mp="23lwi2ka8082a">
                {purchase.name} just purchased this digital system
              </p>
              <p className="mt-0.5 text-[11px] font-medium text-navy-500" data-id="element-49" data-mp="2aqnxr6f2wlc7">
                {purchase.country} • {minutesAgo} minutes ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="-mr-1 -mt-1 rounded-full p-1 text-navy-400 transition-colors duration-150 ease-out hover:bg-navy-50 hover:text-navy-700" data-id="element-50" data-mp="2knaepk4aas8y">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-51" data-mp="1wxoin5j7kt56" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}